export default {
  computed: {
    linkBackButton() {
      const siteId = this.$route.query.siteId;
      const objDate = this.$route.query.objDate;
      const period = this.$route.query.period;
      const objDateNum = Number(objDate);
      if (siteId && objDate && period && !isNaN(objDateNum) && objDateNum > 0) {
        return { path: '/', query: { siteId, objDate: objDateNum, period } };
      }
      return { path: '/' };
    }
  }
};
